import { useEffect, useState } from "react";
import { Box, Stack, TablePagination } from "@mui/material";
import { useTranslation } from "react-i18next";
import AlertCard from "./AlertCard";

const AlertList = ({ alerts, statusLabels, formatDate, selectedId, onOpen }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const lastPage = Math.max(0, Math.ceil(alerts.length / rowsPerPage) - 1);
  const currentPage = Math.min(page, lastPage);

  useEffect(() => {
    if (page > lastPage) setPage(lastPage);
  }, [page, lastPage]);

  return (
    <Box>
      <Stack spacing={1.5}>
        {alerts.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage).map(item => (
          <AlertCard key={item.id} alert={item} statusLabel={statusLabels[item.status] || item.status} formattedDate={formatDate(item.occurred_at)} selected={selectedId === item.id} onOpen={onOpen} />
        ))}
      </Stack>
      {alerts.length > 0 && <TablePagination
        component="div"
        count={alerts.length}
        page={currentPage}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10, 20, 50]}
        onPageChange={(_, nextPage) => setPage(nextPage)}
        onRowsPerPageChange={event => { setRowsPerPage(Number(event.target.value)); setPage(0); }}
        labelRowsPerPage={t("platform.alertCards.perPage")}
        labelDisplayedRows={({ from, to, count }) => t("platform.alertCards.pageRange", { from, to, count })}
        getItemAriaLabel={type => t(`platform.alertCards.pagination.${type}`)}
        sx={{ mt: 2, borderTop: "1px solid", borderColor: "divider", "& .MuiTablePagination-toolbar": { px: 0, gap: 1, flexWrap: "wrap" }, "& .MuiTablePagination-spacer": { display: { xs: "none", sm: "block" } }, "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": { my: 1 }, "& .MuiTablePagination-actions": { ml: { xs: 0, sm: 2 } } }}
      />}
    </Box>
  );
};

export default AlertList;
